import Button from '@mui/material/Button';
import { useNotify, useRefresh, useRecordContext } from 'react-admin';
import { request } from '../services/request';
import { useOktaAuth } from '../security/OktaContext';

const apiUrl = `${import.meta.env.VITE_API_URL}/v1`;

const ReloadScreens = (props) => {
  const { oktaAuth } = useOktaAuth();
  const record = useRecordContext();
  const refresh = useRefresh();
  const notify = useNotify();

  const handleClick = async (event) => {
    event.stopPropagation();

    const active = !record.active;
    const updatedRecord = { ...record, active };
    const requestUrl = `${apiUrl}/settings/refresh`;
    const AuthorizationString = `Bearer ${oktaAuth.getAccessToken()}`;

    const requestOptions = {
      url: requestUrl,
      method: 'get',
      headers: {
        Accept: 'application/json',
        Authorization: AuthorizationString,
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(updatedRecord),
    };

    try {
      await request(requestOptions);
      refresh();
      notify('Refreshing displays', { type: 'success' });
    } catch (err) {
      notify(err.errorData.message, { type: 'warning' });
    }
  };

  return (
    <Button variant="contained" color="secondary" onClick={handleClick}>
      Refresh Screens
    </Button>
  );
};

export default ReloadScreens;
